import { render, staticRenderFns } from "./MessageboxError.vue?vue&type=template&id=f7f99ef8&"
import script from "./MessageboxError.vue?vue&type=script&lang=js&"
export * from "./MessageboxError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports